import { render, staticRenderFns } from "./gj-virtual-select.vue?vue&type=template&id=421dde8c&scoped=true&"
import script from "./gj-virtual-select.vue?vue&type=script&lang=js&"
export * from "./gj-virtual-select.vue?vue&type=script&lang=js&"
import style0 from "./gj-virtual-select.vue?vue&type=style&index=0&id=421dde8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421dde8c",
  null
  
)

export default component.exports